import axios from 'axios'
import _config from '@/config'
import {Message} from 'element-ui';
import { getToken, removeToken } from './token'
 /* eslint-disable */
const config = {
  baseURL: _config.baseUrl,
  timeout: 30 * 1000
}

const _axios = axios.create(config)
const sessionExpiredMessage = '系统检测到账号登录状态异常。为保障账号安全，当前会话已终止，请立即重新登录；如非本人操作，请联系管理员。'
let sessionExpiredHandled = false

function handleUnauthorized(message) {
  if (sessionExpiredHandled) return
  sessionExpiredHandled = true
  removeToken()
  Message({
    message: message || sessionExpiredMessage,
    type: 'warning',
    duration: 5000
  })
  setTimeout(() => {
    window.location.replace(`${window.location.pathname}#/login`)
  }, 5000)
}

_axios.interceptors.request.use(
  originConfig => {
    const accessToken = getToken('access_token')
    originConfig.headers.Authorization = accessToken
    return originConfig
  },
  error => {
    Promise.reject(error)
  }
)

_axios.interceptors.response.use(
  async res => {
    let { data, code, msg } = res.data
    if (code === 401) {
      handleUnauthorized(msg)
      return Promise.reject('未登录')
    }
    if (res.status.toString().charAt(0) === '2') {
      if  (code !== 2000) {
        // 登录接口要求补做安全验证：交给调用方自己切换，不弹全局提示
        if (code === 20002) {
          return { needCaptcha: true }
        }
        Message ({
          message: msg,
          type: 'error',
          duration: 5 * 1000,
        })
        return
      }
      return data
    }
    return new Promise(resolve, reject => {

    })
  },
  error => {
    if (error.response && error.response.status === 401) {
      handleUnauthorized(error.response.data && error.response.data.msg)
      return Promise.reject(error)
    }
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
      Message ({
        type: 'warning',
        message: '请求超时',
        duration: 20 * 1000,
      });
    }
    return Promise.reject(error)
  }
)

export default _axios
